import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useIntl, useDispatch, useSelector } from '@grandvisionhq/state';
import '@grandvisionhq/carts-v2';
import '@grandvisionhq/graphql';
import '@grandvisionhq/payments';
import '@grandvisionhq/utils';
import '@grandvisionhq/api-client';
import { selectShippingMethod } from '../../actions.js';
import { getSelectedShippingMethod } from '../../selectors.js';
import '@grandvisionhq/auth';
import '../../../context/CheckoutSettings/context.js';
import '../../../selectors.js';
import '@grandvisionhq/common';
import '@grandvisionhq/lib-utils-cart';
import '@grandvisionhq/svc-tealium/events';
import '../../../mappers/errors-mapping.js';
import '../../../operations/mutations/set-customer-details.js';
import '../../../operations/mutations/set-service-store.js';
import '../../../operations/mutations/set-shipping-method.js';
import '../../../operations/mutations/set-shipping-state.js';
import '../../../operations/mutations/set-store.js';
import '../../../operations/mutations/create-apple-pay-session.js';
import '../../../operations/mutations/recreate-ordered-checkout.js';
import 'lodash/isEmpty';
import '../../../utils/get-customer-details-payload.js';
import '../../../models/cart/cart-state.js';
import '../../../models/checkout/checkout-step-error-type.js';
import '../../../models/checkout-settings.js';
import '../../../models/step-shipping/shipping-methods.js';
import '../../../models/shared.js';
import 'history';
import '../../../utils/has-cart-errors.js';
import { useSetShippingMethod } from '../../../hooks/operations/use-set-shipping-method.js';
import '@grandvisionhq/frk-routing';
import '@grandvisionhq/fun-orders';
import '@grandvisionhq/analytics';
import '../../../operations/fragments/checkout-mutation-result.js';
import '../../../operations/fragments/cart-mutation-failures.js';
import '../../../operations/fragments/recreate-ordered-checkout-failure.js';
import '../../../operations/fragments/recreate-ordered-checkout-result.js';
import '../../../operations/fragments/paypal-payment.js';
import '../../../operations/fragments/saved-user-details.js';
import '../../../operations/queries/get-checkout-state.js';
import '../../../operations/queries/get-user-details.js';
import { useShippingMethodsList } from '../../modules/ShippingMethods/hooks/use-shipping-methods-list.js';
import { AlternativeShippingMethodsList } from './AlternativeShippingMethodsList.js';

const AlternativeShippingMethodsListContainer = ({ onNextStep , onModalClose  })=>{
    const { getLabel  } = useIntl();
    const dispatch = useDispatch();
    const selectedShippingMethod = useSelector(getSelectedShippingMethod);
    const { reloadShippingMethods  } = useShippingMethodsList();
    const handleOnCompleted = React.useCallback((_, selectedAlternativeShippingMethod)=>{
        dispatch(selectShippingMethod({
            shippingMethod: {
                method: selectedAlternativeShippingMethod,
                isValid: true,
                isTouched: true
            }
        }));
    }, [
        dispatch
    ]);
    const { setShippingMethod  } = useSetShippingMethod({
        onError: ()=>reloadShippingMethods()
        ,
        onCompleted: handleOnCompleted
    });
    const labels = React.useMemo(()=>({
            description: getLabel('cart.shippingMethod.modal.description'),
            buttonCaptionLabel: getLabel('common.actions.continue'),
            free: getLabel('common.free'),
            back: getLabel('cart.actions.goBack'),
            errorTitle: getLabel('cart.shippingMethod.error.title'),
            errorDescription: getLabel('cart.shippingMethod.error.description')
        })
    , [
        getLabel
    ]);
    const handleChange = React.useCallback(function() {
        var _ref = swcHelpers.asyncToGenerator(function*(selectedAlternativeShippingMethod) {
            dispatch(selectShippingMethod({
                shippingMethod: {
                    method: selectedAlternativeShippingMethod === null || selectedAlternativeShippingMethod === void 0 ? void 0 : selectedAlternativeShippingMethod.value,
                    isValid: true,
                    isTouched: true
                }
            }));
            selectedAlternativeShippingMethod && (yield setShippingMethod(selectedAlternativeShippingMethod === null || selectedAlternativeShippingMethod === void 0 ? void 0 : selectedAlternativeShippingMethod.id));
        });
        return function(selectedAlternativeShippingMethod) {
            return _ref.apply(this, arguments);
        };
    }(), [
        dispatch,
        setShippingMethod
    ]);
    const handleSubmit = React.useCallback(()=>{
        onNextStep(true);
    }, [
        onNextStep
    ]);
    return /*#__PURE__*/ React.createElement(AlternativeShippingMethodsList, {
        onModalClose: onModalClose,
        labels: labels,
        selectedShippingMethod: selectedShippingMethod,
        onSubmit: handleSubmit,
        onChange: handleChange
    });
};

export { AlternativeShippingMethodsListContainer };
//# sourceMappingURL=AlternativeShippingMethodsListContainer.js.map
